import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootBtn: {
				background: theme.palette.secondary.light,
				borderRadius: 6,
				border: `1px solid ${theme.palette.secondary.main}`,
				height: 40,
				width: "100%",
				"&:active": {
					cursor: "pointer",
					opacity: 0.7
				}
			},
			button: {
				height: 36,
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				fontWeight: 500,
				display: "flex",
				justifyContent: "space-between",
				"& >img": {
					padding: 7
				}
			},
			logo: {
				display: "flex",
				alignItems: "center",
				"& >img": {
					padding: 7
				}
			}
		}),
	{
		name: "ConfirmRewardCRM",
		index: 1
	}
);

export default useStyles;
